import { useState, useEffect } from 'react';

/**
 * Fetches per-property mobile validation config from General Settings
 * and returns a validateMobile() function that enforces those rules.
 */
function useMobileValidation(token, selectedProperty) {
  const [config, setConfig] = useState({
    minLength: 10,
    maxLength: 10,
    regex: '^[0-9]{10}$',
    dialCode: '+91',
  });

  useEffect(() => {
    const chainId = selectedProperty?.chain_id;
    const propertyId = selectedProperty?.id;
    if (!token || !chainId || !propertyId) return;

    fetch('/api/v1/general/settings', {
      headers: {
        Authorization: `Bearer ${token}`,
        'x-chain-id': chainId,
        'x-property-id': propertyId,
      },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data && data.mobile_min_length) {
          setConfig({
            minLength: data.mobile_min_length,
            maxLength: data.mobile_max_length,
            regex: data.mobile_regex || '^[0-9]{10}$',
            dialCode: data.dial_code || '+91',
          });
        }
      })
      .catch(() => {});
  }, [token, selectedProperty?.chain_id, selectedProperty?.id]);

  /**
   * Returns an error string if invalid, or null if valid.
   * Mobile number is required.
   */
  const validateMobile = (mobile) => {
    const value = String(mobile || '').trim();
    if (!value) return 'Mobile number is required';
    if (value.length < config.minLength)
      return `Mobile must be at least ${config.minLength} digits`;
    if (value.length > config.maxLength)
      return `Mobile must be at most ${config.maxLength} digits`;
    try {
      if (!new RegExp(config.regex).test(value))
        return `Invalid mobile number (expected format: ${config.dialCode} ${config.minLength}-digit number)`;
    } catch (_) {
      // Ignore invalid regex — length checks are sufficient
    }
    return null;
  };

  return { mobileConfig: config, validateMobile };
}

export default useMobileValidation;
